import {IntermediatePart} from "../../intermediatePart";
import {createParentPositions} from "../../constants";

export default class TowelTowelHook extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = "towel_towel_hook";
    this.partName = "Towel";
    this.translateId = "visualizer.bathroom.accessories.towel";
    if (isChild) {
      createParentPositions(this);
    }
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    const robeHook = this.getParent().robeHook;
    if (robeHook && robeHook.layerPositions && robeHook.activeFeature) {
      conditions.push({
        propName: "MatchingFeature",
        propValue: robeHook.activeFeature.getSplittedSku()
      });
    }
    return conditions
  }
}
